/**
 * The void/refund alert (T025, FR-228, FR-229, FR-230).
 *
 * NOT A DRAWER TRIGGER, NOT A TICKET. A sale voided or refunded after its
 * ticket already printed means the barista may already be making it — the
 * fix is stopping a person, not printing a second slip of paper that could
 * be lost in the same pile of tickets it's meant to interrupt. A modal the
 * cashier must dismiss cannot be buried the way a printed notice can.
 *
 * REQUIRES EXPLICIT ACKNOWLEDGEMENT (FR-229). One button, not a toast that
 * fades — the cashier must actually see and dismiss it before the till moves
 * on, the same discipline ManualOpenDialog already applies to a failed
 * drawer release.
 */

export interface VoidAlertDialogProps {
  orderNumber: string;
  onAcknowledge: () => void;
}

export function VoidAlertDialog({ orderNumber, onAcknowledge }: VoidAlertDialogProps) {
  return (
    <div className="voidalert" role="alertdialog" aria-label="Stop this order">
      <div className="voidalert__panel">
        <h2 className="voidalert__title">Stop order {orderNumber}</h2>
        <p className="voidalert__detail">
          This order's ticket already printed. Tell the barista before it's made or handed
          over.
        </p>

        <div className="voidalert__actions">
          <button type="button" className="is-primary" onClick={onAcknowledge}>
            I've told the barista
          </button>
        </div>
      </div>
    </div>
  );
}

export default VoidAlertDialog;
